import { HomePackCategory, HomepackProduct } from '@app-types/home-pack';

export function upperCaseAndAddDash(words: string) {
    return words?.toUpperCase()?.split(' ')?.join('-');
}

function isProductActive(product: HomepackProduct, now: Date) {
    const { startDate, endDate } = product;
    const hasStarted = !startDate || now.getTime() >= startDate.getTime();
    const isExpired = !!endDate && now.getTime() > endDate.getTime();
    return hasStarted && !isExpired;
}

export function filterCategoryByDate(category: HomePackCategory | undefined, now = new Date()) {
    if (!category?.productsSamsung?.length) {
        return category;
    }

    return {
        ...category,
        productsSamsung: category.productsSamsung.filter((product) => isProductActive(product, now)),
    };
}
